import axios from 'axios'
import { Message } from 'element-ui'
import apiEnv from '@/api/env'
import { clearAuthStorage, getToken } from './auth'

// 避免登录失效时重复跳转，造成多次错误提示和页面抖动。
let isRedirecting = false

const service = axios.create({
  baseURL: apiEnv.baseURL,
  timeout: 180000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    // 文件流上传时交给浏览器自动补齐 multipart boundary，避免后端拿不到文件。
    if (config.data instanceof FormData && config.headers) {
      delete config.headers['Content-Type']
    }
    // 后端通过 userreportpack 请求头解析当前登录人身份。
    if (token) {
      config.headers.userreportpack = token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data || {}
    // 当前后端统一使用 status/result/msg/data 结构，成功时直接返回业务体。
    if (res.status === 200 && res.result === 'success') {
      return res
    }

    // 兼容两种错误响应格式：{ status, msg } 和 { code, message }
    const message = res.msg || res.message || '请求失败，请稍后重试'
    Message.error(message)

    // 用户信息失效时清理本地登录态，并回到登录页重新获取权限树。
    if (message.includes('重新登录')) {
      clearAuthStorage()
      if (!isRedirecting && window.location.hash !== '#/login') {
        isRedirecting = true
        window.location.hash = '#/login'
        window.setTimeout(() => {
          isRedirecting = false
        }, 300)
      }
    }

    return Promise.reject(new Error(message))
  },
  error => {
    // 优先提取后端返回的业务错误信息（如 HTTP 500 时后端仍返回 { code, message }）
    const resData = error.response && error.response.data
    const message = (resData && (resData.message || resData.msg)) || error.message || '网络异常，请稍后重试'
    Message.error(message)
    return Promise.reject(error)
  }
)

export default service
